class Settings {
	constructor(config) {
		_validatePropsExist(config, ['adUnit', 'networkId', 'breakpoints', 'sizeMapping', 'slots']);

		if (typeof config.adUnit !== 'string') {
			throw Error('adUnit should be a string');
		}

		if (typeof config.networkId !== 'string' && typeof config.networkId !== 'number') {
			throw Error('networkId should be a string or number');
		}

		this.adUnit = config.adUnit;
		this.networkId = config.networkId;
		this.breakpoints = config.breakpoints;
		this.sizeMapping = config.sizeMapping;
		this.slots = config.slots;

		// Optional props
		this.ppid = config.ppid;
		this.collapseEmpty = config.collapseEmpty;
		this.lazyLoadThreshold = config.lazyLoadThreshold;
		this.refreshThreshold = config.refreshThreshold;
		this.refreshDelay = config.refreshDelay;
		this.requestNonPersonalizedAds = config.requestNonPersonalizedAds;
		this.targeting = config.targeting || {};
		this.customRefreshCallback = config.customRefreshCallback;
	}
}

function _validatePropsExist(obj, props) {
	if (typeof obj === 'undefined') {
		throw Error('Missing settings');
	}

	props.forEach((prop) => {
		if (typeof obj[prop] === 'undefined') {
			throw Error(`Missing required setting: ${prop}`);
		}
	});
}

module.exports = Settings;
